import React from 'react'
import {Text, View} from '@react-pdf/renderer'
import {IIncomeDocument} from '../IncomeDocumentDetailPage'
import {numberFormat} from '../../../utils/Functions'
import moment from 'moment'
import usePayment from '../../../hook/usePayment'

interface IPrintPaymentSection {
  document: IIncomeDocument
}

const PrintPaymentSection: React.FC<IPrintPaymentSection> = (props) => {
  const { document } = props
  const { getBankLabelByCode } = usePayment()
  const payments = document.incomeDocumentPayments

  const payByCash = payments.filter((payment) => payment.bank === 'cash')
  const payByBankTransfer = payments.filter((payment) => payment.bank !== 'cash' && !payment?.chequeNumber)
  const payByCheck = payments.filter((payment) => !!payment.chequeNumber)
  const totalCash = payByCash.reduce((total, payment) => total + Number(payment.amount || 0), 0)
  const totalBankTransfer = payByBankTransfer.reduce(
    (total, payment) => total + Number(payment.amount || 0),
    0
  )
  const totalCheck = payByCheck.reduce((total, payment) => total + Number(payment.amount || 0), 0)
  const bankTransferBanks = payByBankTransfer
    .map((payment) => (payment.bank ? getBankLabelByCode(payment.bank) : ''))
    .filter(Boolean)
    .join(', ')
  const bankTransferAccounts = payByBankTransfer
    .map((payment) => payment.accountNo)
    .filter(Boolean)
    .join(', ')
  const chequeBanks = payByCheck
    .map((payment) => (payment.chequeBank ? getBankLabelByCode(payment.chequeBank) : ''))
    .filter(Boolean)
    .join(', ')
  const chequeBranches = payByCheck.map((payment) => payment.chequeBranchNumber).filter(Boolean).join(', ')
  const chequeNumbers = payByCheck.map((payment) => payment.chequeNumber).filter(Boolean).join(', ')
  const chequeDates = payByCheck
    .map((payment) => (payment.chequeDate ? moment(payment.chequeDate).format('DD/MM/YYYY') : ''))
    .filter(Boolean)
    .join(', ')

  return (
    <View style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', borderTop: '1px solid #bfbfbf', padding: '8px 0'}}>
      <View style={{width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'flex-start', gap: '8px', padding: '8px 0'}}>
        <View style={{display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '4px', minWidth: '50px'}}>
          <Text style={{fontFamily: 'FontAwesome', fontSize: 9}}>{'\uf0d6'}</Text>
          <Text style={{fontWeight: 'bold'}}>{'ชำระเงิน'}</Text>
        </View>
        <View style={{flex: '1'}}>
          <View style={{display: 'flex', alignItems: 'center', flexDirection: 'row', gap: '2px'}}>
            <View style={{width: 30}}>
              <Text>{'ชำระโดย'}</Text>
            </View>
            <View style={{display: 'flex', alignItems: 'center', flexDirection: 'row', gap: '4px'}}>
              <View style={{width: '9px', height: '9px', border: '1px solid black', backgroundColor: payByCash.length ? '#000' : '' }}></View>
              <Text>{'เงินสด'}</Text>
            </View>
            <View style={{display: 'flex', alignItems: 'center', flexDirection: 'row', gap: '4px', marginLeft: '8px'}}>
              <View style={{width: '9px', height: '9px', border: '1px solid black', backgroundColor: payByBankTransfer.length ? '#000' : ''}}></View>
              <Text>{'เงินโอน'}</Text>
            </View>
            <View style={{display: 'flex', alignItems: 'center', flexDirection: 'row', gap: '4px', marginLeft: '8px'}}>
              <Text>{'จำนวน'}</Text>
              <Text style={{width: 80, borderBottom: '1px dashed black', textAlign: 'center'}}>{(payByCash?.length || payByBankTransfer?.length) ? numberFormat(totalCash + totalBankTransfer) : '-'}</Text>
              <Text>{'บาท'}</Text>
            </View>
            <View style={{flex: '1', display: 'flex', alignItems: 'center', flexDirection: 'row', gap: '4px', marginLeft: '8px'}}>
              <Text>{'ธนาคาร'}</Text>
              <Text style={{flex: '1', borderBottom: '1px dashed black', textAlign: 'center'}}>{bankTransferBanks || '-'}</Text>
            </View>
            <View style={{flex: '1', display: 'flex', alignItems: 'center', flexDirection: 'row', gap: '4px', marginLeft: '8px'}}>
              <Text>{'เลขบัญชี'}</Text>
              <Text style={{flex: '1', borderBottom: '1px dashed black', textAlign: 'center'}}>{bankTransferAccounts || '-'}</Text>
            </View>
          </View>
        </View>
      </View>
      <View style={{display: 'flex', flexDirection: 'row', alignItems: 'center', width: '100%'}}>
        <View style={{display: 'flex', alignItems: 'center', flexDirection: 'row', gap: '4px'}}>
          <View style={{width: '9px', height: '9px', border: '1px solid black', backgroundColor: payByCheck.length ? '#000' : ''}}></View>
          <Text>{'เช็ค'}</Text>
        </View>
        <View style={{flex: '1', display: 'flex', alignItems: 'center', flexDirection: 'row', gap: '4px', marginLeft: '8px'}}>
          <Text>{'ธนาคาร'}</Text>
          <Text style={{flex: '1', borderBottom: '1px dashed black', textAlign: 'center'}}>{chequeBanks || '-'}</Text>
        </View>
        <View style={{flex: '1', display: 'flex', alignItems: 'center', flexDirection: 'row', gap: '4px', marginLeft: '8px'}}>
          <Text>{'สาขา'}</Text>
          <Text style={{flex: '1', borderBottom: '1px dashed black', textAlign: 'center'}}>{chequeBranches || '-'}</Text>
        </View>
        <View style={{flex: '1', display: 'flex', alignItems: 'center', flexDirection: 'row', gap: '4px', marginLeft: '8px'}}>
          <Text>{'เลขที่เช็ค'}</Text>
          <Text style={{flex: '1', borderBottom: '1px dashed black', textAlign: 'center'}}>{chequeNumbers || '-'}</Text>
        </View>
        <View style={{flex: '1', display: 'flex', alignItems: 'center', flexDirection: 'row', gap: '4px', marginLeft: '8px'}}>
          <Text>{'ลงวันที่'}</Text>
          <Text style={{flex: '1', borderBottom: '1px dashed black', textAlign: 'center'}}>{chequeDates || '-'}</Text>
        </View>
        <View style={{flex: '1', display: 'flex', alignItems: 'center', flexDirection: 'row', gap: '4px', marginLeft: '8px'}}>
          <Text>{'จำนวน'}</Text>
          <Text style={{flex: '1', borderBottom: '1px dashed black', textAlign: 'center'}}>{totalCheck ? numberFormat(totalCheck) : '-'}</Text>
          <Text>{'บาท'}</Text>
        </View>
      </View>
    </View>
  )
}

export default PrintPaymentSection
